import { z } from 'zod';
export const metricTrendSchema = z.object({
    value: z.number().nullable(),
    trend: z.number().nullable(),
    trendType: z.enum(['percentage', 'absolute']),
    sparkline: z.array(z.number()),
});
export const dashboardSummarySchema = z.object({
    activePRs: metricTrendSchema,
    codeQuality: metricTrendSchema,
    workItems: metricTrendSchema,
    monitoredRepos: metricTrendSchema,
});
export const qualityTrendPointSchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format'),
    score: z.number().min(0).max(10),
    trend: z.number().finite(),
});
export const qualityTrendSchema = z.object({
    organizationId: z.string().uuid(),
    range: z.union([
        z.literal('7d'),
        z.literal('30d'),
        z.literal('60d'),
        z.literal('90d'),
        z.literal('custom'),
        // Also accept numeric values for backwards compatibility
        z.literal(7),
        z.literal(30),
        z.literal(60),
        z.literal(90),
    ]),
    data: z.array(qualityTrendPointSchema).max(366),
    summary: z.object({
        currentScore: z.number().min(0).max(10),
        trendDirection: z.enum(['up', 'down', 'stable']),
        improvement: z.number().finite(),
    }),
});
// Note: QualityTrendResponse and QualityTrendPoint types are exported from types/dashboard.ts
// to avoid conflicts. Use those for TypeScript types, use schemas for validation.
export const engineerPerformanceSchema = z.object({
    user_id: z.string().uuid().nullable(),
    name: z.string(),
    avatar_url: z.string().optional().nullable(),
    score: z.number(),
    delta: z.number(),
    rank: z.number(),
});
export const topPerformersResponseSchema = z.object({
    top_performers: z.array(engineerPerformanceSchema),
    most_improved: z.array(engineerPerformanceSchema),
});
export const issueCategorySchema = z.object({
    category: z.string(),
    count: z.number(),
    percentage: z.number(),
    color: z.string().optional(),
});
export const issueDistributionResponseSchema = z.object({
    categories: z.array(issueCategorySchema),
    total: z.number(),
});
//# sourceMappingURL=dashboard.js.map